import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fnsr-privacy',
  templateUrl: './privacy.component.html'
})
export class PrivacyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
